import React from "react";
import { Checkbox, Col, ControlLabel, FormGroup, Panel, Row, FormControl, } from "react-bootstrap";

import { ethnicities, maritalOptions, statusTypes } from "../config/constants";

const DemographicInfoStatic = (props) => {
  const {
    studentEthnicity,
    phones,
    address,
    email,
    deltaId,
    gender,
    name,
    maritalStatus
  } = props;

  const mappedEthnicity = ethnicities.map(
    (ethnicity, index) => {
      return {
        name: ethnicity,
        checked: studentEthnicity.charAt(index) === 'Y',
        id: index
      }
    }
  );

  const renderEthnicities = () => {
    return (
      <Row>
        <FormGroup>
          <Col md={12}>
            <ControlLabel>Ethnicity</ControlLabel>
          </Col>
          <Col md={4}>
            {mappedEthnicity.filter((ethnicity, index) => index % 3 === 0).map(ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} readOnly>{ethnicity.name}</Checkbox>)}
          </Col>
          <Col md={4}>
            {mappedEthnicity.filter((ethnicity, index) => index % 3 === 1).map(ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} readOnly>{ethnicity.name}</Checkbox>)}
          </Col>
          <Col md={4}>
            {mappedEthnicity.filter((ethnicity, index) => index % 3 === 2).map(ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} readOnly>{ethnicity.name}</Checkbox>)}
          </Col>
        </FormGroup>
      </Row>
    )
  };

  const renderMaritalStatus = () => {
    const maritalValue = maritalOptions.find((option) => option.value === maritalStatus);
    const maritalText = maritalValue ? maritalValue.text : '';
    return (
      <FormGroup controlId='marital-status'>
        <ControlLabel>
          Marital Status
        </ControlLabel>
        <FormControl.Static>
          {maritalText}
        </FormControl.Static>
      </FormGroup>
    )
  };

  return (
    <Panel bsStyle={statusTypes.INFO}>
      <Panel.Heading>Demographic Information</Panel.Heading>
      <Panel.Body>
        <Row>
          <Col md={6}>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>
                Delta Id
              </ControlLabel>
              <FormControl.Static>
                {deltaId}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>
                Gender
              </ControlLabel>
              <FormControl.Static>
                {gender}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>
                Student Email
              </ControlLabel>
              <FormControl.Static>
                {email}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>
                First Name
              </ControlLabel>
              <FormControl.Static>
                {name.firstName}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>
                Middle Name
              </ControlLabel>
              <FormControl.Static>
                {name.middleName}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup>
              <ControlLabel>
                Last Name
              </ControlLabel>
              <FormControl.Static>
                {name.lastName}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>
                Street Address
              </ControlLabel>
              <FormControl.Static>
                {address.address1}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>
                City
              </ControlLabel>
              <FormControl.Static>
                {address.city}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup>
              <ControlLabel>
                State
              </ControlLabel>
              <FormControl.Static>
                {address.state}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup>
              <ControlLabel>
                Zip Code
              </ControlLabel>
              <FormControl.Static>
                {address.zip}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>
                Home Phone Number
              </ControlLabel>
              <FormControl.Static>
                {phones.home || 'None Provided'}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>
                Cell Phone Number
              </ControlLabel>
              <FormControl.Static>
                {phones.cell || 'None Provided'}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>
                Work Phone Number
              </ControlLabel>
              <FormControl.Static>
                {phones.work || 'None Provided'}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>
                Emergency Phone Number
              </ControlLabel>
              <FormControl.Static>
                {phones.emergency || 'None Provided'}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
        {renderEthnicities()}
        {renderMaritalStatus()}
      </Panel.Body>
    </Panel>
  )
};

export default DemographicInfoStatic